<template>
    <span class="footer-menu-item-text">
        {{ data.text }}
    </span>
</template>

<script setup lang="ts">
import type { FooterItemTextFragment } from '@/graphql/api'

defineProps<{
    data: FooterItemTextFragment
}>()
</script>

<style lang="scss" scoped>
.footer-menu-item-text {
    display: block;
    line-height: 25px;
}
</style>
